import { forwardRef } from 'react'
import clsx from 'clsx'
import { PostText } from './components'
import { PostHTML } from './postDescription.styles'
import { PostDescriptionProps } from './postDescription.types'

const PostDescription = forwardRef<HTMLDivElement, PostDescriptionProps>(
  ({ description, limitChars, className }, ref) => {
    /**
     * Foi necessário incluir essa Regex para contornar o problema de renderização
     * dos posts antigos (com quebra de linha e sem HTML) e dos posts novos que
     * foram criados com o editor rich text.
     */
    const hasHTMLTags =
      description &&
      /<(?!br\b)([a-zA-Z][a-zA-Z0-9]*)\b[^>]*>(.*?)<\/\1>|<br\s*(?:\/)?>/.test(description)

    return (
      <>
        {hasHTMLTags ? (
          <PostHTML
            className={className}
            data-test="html-content"
            ref={ref}
            $limitChars={limitChars}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        ) : (
          <PostText
            className={clsx('_pb-4', className)}
            data-test="raw-content"
            description={description}
          />
        )}
      </>
    )
  }
)

export default PostDescription
